module.exports = __webpack_public_path__ + "img/Golang.f1f937a.svg";